import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import { User } from 'oidc-client-ts';
import axios, { AxiosError, CancelTokenSource } from 'axios';



export interface UserState {
    user: User | null;
    isUserLoad: boolean;
}

export interface LoadUserAction {
    type: 'LOAD_USER';
    user: User;
}

export interface UnLoadUserAction {
    type: 'UNLOAD_USER';
}


type KnownAction = LoadUserAction | UnLoadUserAction;


export const actionCreators = {

    LoadUserAction: (user: User): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        axios.defaults.headers.common = {'Authorization': `Bearer ${user.access_token||''}`}  ;
        dispatch({
            type: 'LOAD_USER',
            user: user
        });

    },
    UnLoadUserAction: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        dispatch({
            type: 'UNLOAD_USER',
        });

    },



};

const unloadedState: UserState = {
    user: null, isUserLoad: false
};

export const reducer: Reducer<UserState> = (state: UserState | undefined, incomingAction: Action): UserState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'LOAD_USER':
       

            return {
                ...state,
                user: action.user,
                isUserLoad: state.isUserLoad === false ? true : state.isUserLoad,

            };
        case 'UNLOAD_USER':
            return {
                ...state,
                user: null,
                isUserLoad: false,

            };
        default:
            return state;
    };


};